import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@chakra-ui/react';
import { CheckCircleIcon } from '@chakra-ui/icons';

export const TopListingBenefits = () => {
  const { t } = useTranslation();
  return (
    <Flex gap="4" direction="column" mb={4} px={4} py={2}>
      <Flex align="center" gap="2">
        <CheckCircleIcon color="primary" />
        <Text fontSize="md">{t('products.createModal.topListing.benefit1')}</Text>
      </Flex>
      <Flex align="center" gap="2">
        <CheckCircleIcon color="primary" />
        <Text fontSize="md">{t('products.createModal.topListing.benefit2')}</Text>
      </Flex>
    </Flex>
  );
};
